// src/marketing/launch/MilestoneGroup.tsx
import type { LaunchTask } from '../../lib/types'
import { Badge } from '../editorial/Badge'
import { TaskRow } from './TaskRow'

type Props = {
  milestone: string
  milestoneOrder: number
  tasks: LaunchTask[]
  launchDate: string | null
  onToggle: (id: string, done: boolean) => void
  onEdit: (task: LaunchTask) => void
  onDelete: (id: string) => void
  onAddTask: (milestone: string, milestoneOrder: number) => void
}

export function MilestoneGroup({
  milestone,
  milestoneOrder,
  tasks,
  launchDate,
  onToggle,
  onEdit,
  onDelete,
  onAddTask,
}: Props) {
  const doneCount = tasks.filter((t) => t.done).length
  const allDone = doneCount === tasks.length && tasks.length > 0

  return (
    <section className="xsec">
      <div className="xhead">
        <div>
          <div className="xrel">Jalon {milestoneOrder + 1}</div>
          <h2>
            <Badge variant="jalon">{milestone}</Badge>
          </h2>
        </div>
        <div className="xhead-r">
          <span className={`xcount${allDone ? ' full' : ''}`}>
            {doneCount}/{tasks.length}
          </span>
          <button
            onClick={() => onAddTask(milestone, milestoneOrder)}
            style={{
              background: 'none',
              border: '1px solid var(--line)',
              borderRadius: '4px',
              padding: '4px 10px',
              fontSize: '0.75rem',
              color: 'var(--muted)',
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            + Ajouter
          </button>
        </div>
      </div>
      <ul className="xlist">
        {tasks.map((t) => (
          <TaskRow
            key={t.id}
            task={t}
            launchDate={launchDate}
            onToggle={onToggle}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        ))}
      </ul>
    </section>
  )
}
